/**
 * Le scene della mascotte (Mascotte.tsx) e quanto durano. Stanno in un file a parte e
 * non nel componente: un file .tsx che esporta anche costanti non si aggiorna al volo
 * (Fast Refresh) e a ogni modifica la pagina si ricaricava tutta, pannello compreso.
 *
 * Chi le fa partire e quando: features/assistente/mascotteVita.ts. Il confronto di
 * tutte le scene, una accanto all'altra: /mascotte (MascotteGalleria.tsx).
 */
export type StatoMascotte =
  // Di base
  | 'pronto' | 'nasce'
  // La conversazione
  | 'ascolta' | 'pensa' | 'parla' | 'errore'
  // Reazioni
  | 'saluta' | 'contento' | 'felice' | 'taglia' | 'stupito' | 'stordito' | 'capriola'
  // La giornata
  | 'te' | 'mangia' | 'allena' | 'stiracchia' | 'balla' | 'dorme' | 'pisolino' | 'sveglia'
  // Il gestionale
  | 'indica' | 'spinge' | 'moneta' | 'ombrello';

/** I costumi delle feste: si mettono sopra qualunque scena. */
export type CostumeMascotte = 'zucca' | 'natale' | 'capodanno';

/** Quanto dura una scena breve, in millisecondi. Le altre restano finché cambiano. */
export const DURATA_SCENA: Partial<Record<StatoMascotte, number>> = {
  nasce: 1300,
  felice: 1700,
  taglia: 1000,
  errore: 1300,
  saluta: 2200,
  stupito: 900,
  sveglia: 1100,
  stordito: 1800,
  capriola: 1200,
  allena: 2600,
  stiracchia: 2400,
  balla: 3200,
  indica: 2400,
  spinge: 4400,
  moneta: 1800,
};

/**
 * «spinge» (mascotte.css): arriva a «Da fare» al 16% della scena e ci resta fino
 * all'80%, otto colpetti da 352 ms saltellando. Il bottone sobbalza a tempo (Topbar).
 */
export const SPINTA_CONTATTO_MS = 704;
export const SPINTA_DURATA_CONTATTO_MS = 2816;
